import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as TransferHttp from '../../../../services/api/https/deliveries/delivery-transfer.http'
import {
  convertToFormatedDateString,
  getPeriodoFromLastXDays,
} from '../../../../services/util/date.service'
import { urlReportMapaCarregamentoEstoqueTransferencia } from '../../../../services/api/routes/delivery-transfer.routes'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

export const MODAL_TYPES = {
  NONE: 'NONE',
  CONFIRMACAO_TRANSFERENCIA: 'CONFIRMACAO_TRANSFERENCIA',
  CONFIRMACAO_CANCELAMENTO: 'CONFIRMACAO_CANCELAMENTO',
  FORMULARIO: 'FORMULARIO',
}

const { pInicial: dataInicial, pFinal: dataFinal } = getPeriodoFromLastXDays(31)

const INITIAL_STATE = {
  isLoading: true,
  transferencias: [],
  originalTransferencias: [],
  errorMessage: null,
  successMessage: null,
  transferenciaSelecionada: null,
  modalType: MODAL_TYPES.NONE,
  navigateToAssociacaoEntregas: false,
  periodoInicial: dataInicial,
  periodoFinal: dataFinal,
  globalFilter: '',
  notaFiscal: '',
  transferenciasSelecionadas: [],
}

export default function useTransferenciaEntrega() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      async onPesquisarTransferencia(selectedTp, pInicial, pFinal) {
        setState(prevState => ({
          ...prevState,
          periodoInicial: pInicial,
          periodoFinal: pFinal,
          isLoading: true,
          notaFiscal: '',
        }))
        try {
          const transferencias = await TransferHttp.getTransfers(selectedTp, pInicial, pFinal)

          setState(prevState => ({
            ...prevState,
            transferencias,
            originalTransferencias: transferencias,
            isLoading: false,
            notaFiscal: '',
            transferenciasSelecionadas: [],
          }))
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            errorMessage: errorHandler(error),
            isLoading: false,
          }))
        }
      },

      resetMessage() {
        setState(prevState => ({ ...prevState, errorMessage: null, successMessage: null }))
      },

      editarTransferencia(transferencia) {
        if (transferencia.status === 'Cancelada') {
          setState(prevState => ({ ...prevState, errorMessage: 'Transferência já Cancelada' }))
        } else {
          const formattedTransferencia = {
            ...transferencia,
            departure_date: transferencia.departure_date
              ? new Date(transferencia.departure_date)
              : '',
            departure_time: transferencia.departure_time.substring(0, 5),
          }
          setState(prevState => ({
            ...prevState,
            transferenciaSelecionada: formattedTransferencia,
            modalType: MODAL_TYPES.FORMULARIO,
          }))
        }
      },
      navigateToCargasParadas() {
        setState(prevState => ({
          ...prevState,
          pathToRedirect: '/main/entregas/cargas-paradas-transferencia',
        }))
      },

      navigateToAssociacaoEntregas(transferencia) {
        if (transferencia.status === 'Cancelada') {
          setState(prevState => ({ ...prevState, errorMessage: 'Transferência já Cancelada' }))
        } else {
          setState(prevState => ({
            ...prevState,
            pathToRedirect: '/main/entregas/transferencia-assoc-entrega',
            transferenciaSelecionada: transferencia,
          }))
        }
      },

      confirmarTransferencia(transferencia) {
        if (transferencia.status === 'Cancelada') {
          setState(prevState => ({ ...prevState, errorMessage: 'Transferência já Cancelada' }))
        } else {
          setState(prevState => ({
            ...prevState,
            modalType: MODAL_TYPES.CONFIRMACAO_TRANSFERENCIA,
            transferenciaSelecionada: transferencia,
          }))
        }
      },

      confirmarCancelamento(transferencia) {
        setState(prevState => ({
          ...prevState,
          modalType: MODAL_TYPES.CONFIRMACAO_CANCELAMENTO,
          transferenciaSelecionada: transferencia,
        }))
      },

      async changeStatus(transferencia, status) {
        try {
          const { transfer_id } = transferencia

          status === 'Transferir'
            ? await TransferHttp.changeStatusToTransfered(transfer_id)
            : await TransferHttp.changeStatusToCanceled(transfer_id)

          setState(prevState => {
            return {
              ...prevState,
              successMessage: 'Operação realizada com sucesso',
              modalType: MODAL_TYPES.NONE,
            }
          })
        } catch (error) {
          setState(prevState => ({ ...prevState, errorMessage: errorHandler(error) }))
        }
      },

      closeModal() {
        setState(prevState => ({ ...prevState, modalType: MODAL_TYPES.NONE }))
      },

      modalFormularioResponseHandler(action, payload) {
        switch (action) {
          case 'Close':
            localDispatch.closeModal()
            break
          case 'Error':
            setState(prevState => ({ ...prevState, errorMessage: errorHandler(payload) }))
            break
          case 'Saved':
            setState(prevState => ({
              ...prevState,
              modalType: MODAL_TYPES.NONE,
              successMessage: 'Operação realizada com sucesso',
            }))
            break
          default:
            break
        }
      },

      novaTransferencia(tpId) {
        tpId && tpId > 0
          ? setState(prevState => ({
              ...prevState,
              modalType: MODAL_TYPES.FORMULARIO,
              transferenciaSelecionada: null,
            }))
          : setState(prevState => ({
              ...prevState,
              errorMessage: 'Selecione o Operador Logístico',
            }))
      },
      onItemClick(item, transferencia, selectedTp) {
        switch (item) {
          case 'Editar':
            localDispatch.editarTransferencia(transferencia)
            break
          case 'Transferir':
            localDispatch.confirmarTransferencia(transferencia)
            break
          case 'Assoc. Entregas':
            localDispatch.navigateToAssociacaoEntregas(transferencia)
            break
          case 'Mapa de Carregamento - Estoque':
            localDispatch.onBtnMapaCarregamentoEstoqueClick(transferencia, selectedTp)
            break
          case 'Cancelar Transferência':
            localDispatch.confirmarCancelamento(transferencia)
            break
          default:
            break
        }
      },

      setGlobalFilter(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      setTransferenciasSelecionadas(value) {
        setState(prevState => ({ ...prevState, transferenciasSelecionadas: value }))
      },

      async onBtnExportarClick(transferenciasSelecionadas) {
        if (!transferenciasSelecionadas || transferenciasSelecionadas.length === 0) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Nenhuma transferência selecionada',
          }))
          return
        }

        try {
          setState(prevState => ({
            ...prevState,
            isLoading: true,
            loadingMessage: 'Gerando arquivo',
          }))

          const entregas = await TransferHttp.getDeliveriesForTransferExport(
            transferenciasSelecionadas.map(t => t.transfer_id).join(','),
          )

          const colunas = [
            [
              'Código',
              'Transferência',
              'Destino',
              'Status',
              'Data Importação',
              'Ciclo',
              'Data da Partida',
              'Horário da Partida',
              'Placa',
              'NF/Identificador',
              'Embarcador/Empresa',
              'Cidade',
              'Qte.Volumes',
              'Peso',
            ],
          ]

          entregas.forEach(e => {
            colunas.push([
              e.transfer_id,
              e.transfer_name,
              e.tp_name,
              e.status,
              convertToFormatedDateString(e.created_at),
              e.cycle_id,
              convertToFormatedDateString(e.departure_date),
              e.departure_time,
              e.vehicle_plate,
              e.identifier,
              e.company_name,
              e.city,
              e.qte_sku,
              e.weight,
            ])
          })

          gerarArquivoExcel('Entregas Transferências', colunas, 'entregas_transferencias.xlsx')
          setState(prevState => ({ ...prevState, isLoading: false, loadingMessage: null }))
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            isLoading: false,
            loadingMessage: null,
            errorMessage: errorHandler(error),
          }))
        }
      },

      setNotaFiscal(value) {
        setState(prevState => ({ ...prevState, notaFiscal: value }))
      },

      filtrarPorNota() {
        setState(prevState => {
          const nf = prevState.notaFiscal.trim()
          if (nf === '') {
            // Se vazio, restaura a lista completa
            return {
              ...prevState,
              transferencias: prevState.originalTransferencias,
            }
          }

          // Filtra cada transferência cujo campo `identifiers` contenha a NF digitada
          const filtradas = prevState.originalTransferencias.filter(
            item => item.identifiers && item.identifiers.split(' ').includes(nf),
          )
          return { ...prevState, transferencias: filtradas }
        })
      },

      onBtnMapaCarregamentoEstoqueClick(transferencia, selectedTp) {
        // Validação: verificar se a transferência tem entregas associadas
        if (!transferencia.qte_deliveries || transferencia.qte_deliveries === 0) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Nenhuma entrega associada a transferência',
          }))
          return
        }

        if(transferencia.status === 'Cancelada') {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Transferência cancelada',
          }))
          return
        }

        if(transferencia.status === 'Transferida') {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Não é possível emitir o Mapa de Carregamento de Estoque pois a transferência já foi realizada',
          }))
          return
        }

        // Abrir o report
        const url = urlReportMapaCarregamentoEstoqueTransferencia(
          selectedTp,
          transferencia.transfer_id,
        )
        window.open(url, '_blank')
      },
    }
  }, [])

  return { state, localDispatch }
}
